module.exports = __webpack_public_path__ + "static/img/IMG_20170905_192753.8830a6e7.jpg";